import { useState, useEffect } from 'react';
import './Links.css';
import logo from '../assets/dangol-logo-1.png';
import appStoreBadge from '../assets/app-store-badge.svg';
import googlePlayBadge from '../assets/google-play-badge.svg';
import { detectPlatform } from '../utils/platformDetect';

const APP_STORE_URL = 'https://apps.apple.com/us/app/dangol/id6752506557';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.dangolapp.dangol&pcampaignid=web_share';

const Links = () => {
  const [redirecting, setRedirecting] = useState(false);

  useEffect(() => {
    const platform = detectPlatform(navigator.userAgent);

    if (platform === 'ios') {
      setRedirecting(true);
      window.location.replace(APP_STORE_URL);
    } else if (platform === 'android') {
      setRedirecting(true);
      window.location.replace(PLAY_STORE_URL);
    }
  }, []);

  if (redirecting) {
    return (
      <div className="links">
        <div className="links-header">
          <div className="links-logo">
            <img src={logo} alt="Dangol" />
          </div>
          <h1 className="links-title">Dangol</h1>
        </div>
        <div className="links-content">
          <p className="links-subtitle">Redirecting to your app store...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="links">
      <div className="links-header">
        <div className="links-logo">
          <img src={logo} alt="Dangol" />
        </div>
        <h1 className="links-title">Dangol</h1>
      </div>

      <div className="links-content">
        <p className="links-subtitle">Download our app</p>
        <div className="links-buttons">
          <a
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="store-badge-link"
          >
            <img
              src={appStoreBadge}
              alt="Download on the App Store"
              className="store-badge"
            />
          </a>
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="store-badge-link"
          >
            <img
              src={googlePlayBadge}
              alt="Get it on Google Play"
              className="store-badge"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Links;
